import { apiGet } from "../../utils"

export function getAvailableDateRangesAPI(store) {
    const query = store ? `?store=${store}` : ''
    return apiGet(`/api/getAvailableDateRanges${query}`)
}

export function getAnalyticsDataAPI(filename) {
    return apiGet(`/api/getAnalyticsData?file=${encodeURIComponent(filename)}`)
}
